module.exports = __webpack_public_path__ + "static/Thumb_MM_S07_Drone_MM-4c6f2ea589cbec26ed6895f3b6553d5d.png";